import QuestionnaireAnswer from "@/models/QuestionnaireAnswer";

export default class QuestionnaireOption {
    constructor(raw = {}) {
        this.id = raw.id;
        this.question = raw.question;
        this.options = raw.options ? raw.options.map(option => new QuestionnaireAnswer(option)) : [];
    }

}
